// extracted by mini-css-extract-plugin
export default {"someContainer":"style_someContainer__UU4b1","someIcon":"style_someIcon__enn7R","link":"style_link__71s36"};